import { useSyncExternalStore } from 'react';

import { formatMoney } from '@core/money';

import { store, type AppState } from './store';

export function useApp(): AppState {
  return useSyncExternalStore(store.subscribe, store.get);
}

export function useMoney() {
  const currency = useApp().user?.currency ?? 'INR';
  return {
    currency,
    format: (minor: number, compact = false) => formatMoney(minor, currency, { compact }),
    /** Whole units, for averages. */
    formatWhole: (minor: number) => formatMoney(minor, currency, { decimals: 'none' }),
  };
}
